import React from "react";
import { useI18n } from "../i18n";
import "./whatsapp.css";

const MSG = {
  es: "Hola, he visto Lura Finance y me gustaría recibir más información.",
  en: "Hi, I saw Lura Finance and I'd like to get more information.",
  fr: "Bonjour, j'ai vu Lura Finance et j'aimerais recevoir plus d'informations.",
  pt: "Olá, vi a Lura Finance e gostaria de receber mais informações.",
  it: "Ciao, ho visto Lura Finance e vorrei ricevere più informazioni.",
};

const LABEL = {
  es: "Escríbenos por WhatsApp",
  en: "Message us on WhatsApp",
  fr: "Écrivez-nous sur WhatsApp",
  pt: "Fale conosco no WhatsApp",
  it: "Scrivici su WhatsApp",
};

const WaIcon = () => (
  <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.74 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.6h.01c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.33-6.63-3.75-9.05a12.72 12.72 0 0 0-9.06-3.63zm0 23.3h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4 1.05 1.07-3.9-.25-.4a10.56 10.56 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.5 1.11 7.51 3.12a10.56 10.56 0 0 1 3.11 7.52c0 5.86-4.77 10.63-10.63 10.63zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55l-.6-.01c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66s1.15 3.08 1.3 3.29c.16.21 2.26 3.45 5.48 4.84.77.33 1.36.53 1.82.68.77.24 1.47.21 2.02.13.62-.09 1.89-.77 2.16-1.52.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export function WhatsAppButton() {
  const { locale } = useI18n();
  const number = process.env.REACT_APP_WHATSAPP_NUMBER;

  if (!number) return null;

  const msg = MSG[locale] || MSG.es;
  const label = LABEL[locale] || LABEL.es;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-fab wa-fab--in"
      aria-label={label}
      title={label}
      data-testid="whatsapp-float-button"
    >
      <span className="wa-fab__ring" aria-hidden="true" />
      <span className="wa-fab__icon"><WaIcon /></span>
      <span className="wa-fab__label">{label}</span>
    </a>
  );
}
